export const definity = {
  colour: {
    primary: '#147582',
    primary_variant: '#095D68',
    primary_label: '#FFFFFF',

    secondary: '#6EBAC5',
    secondary_variant: '#ACDDE4',
    secondary_label: '#323232',

    tertiary: '#323232',
    tertiary_variant: '#6F6F6F',
    tertiary_label: '#FFFFFF',

    background: '#F2F2F2',
    background_label: '#323232',

    surface: '#FFFFFF',
    surface_label: '#323232',

    form_field: '#FFFFFF',
    form_field_label: '#323232',
    form_field_border: '#6F6F6F',
    form_field_border_hover: '#147582',
    form_field_border_focus: '#6EBAC5',
    form_field_hint: '#6F6F6F',
    form_field_error_message: '#E12160',

    error: '#E12160',
    error_label: '#FFFFFF',

    hyperlink: '#147582',
    hyperlink_hover_state: '#9E0A9A',
  },
  button: {
    border: '1em',
  },
};
